import { helper } from '@ember/component/helper';

const IS_UP_TREND_POSITIVE = {
  sent: true,
  opened: true,
  clicked: true,
  converted: true,
  unsubscribed: false,
  delivered: true,
  bounced: false,
  failed: false,
  suppressed: false,
  spammed: false,
} as const;

export function metricsChangeFromLast([measure, values, isRate]: [
  keyof typeof IS_UP_TREND_POSITIVE,
  (number | null)[],
  boolean,
]) {
  let change: {
    diff: number | null;
    trend: string;
    sign: string;
    iconType: string;
  } = {
    diff: null,
    trend: 'none',
    sign: '',
    iconType: '',
  };

  if (!values || values.length < 2) {
    return change;
  }

  let [secondToLastPoint, lastPoint] = values.slice(-2);

  if (lastPoint != null && secondToLastPoint != null) {
    let diff = lastPoint - secondToLastPoint;
    if (diff > 0) {
      change = {
        diff,
        trend: 'up',
        sign: '+',
        iconType: IS_UP_TREND_POSITIVE[measure] ? 'positive' : 'negative',
      };
    }

    if (diff < 0) {
      change = {
        diff,
        trend: 'down',
        sign: '-',
        iconType: IS_UP_TREND_POSITIVE[measure] ? 'negative' : 'positive',
      };
    }

    change.diff = Math.abs(isRate ? diff / 100 : diff);
  }

  return change;
}

export default helper(metricsChangeFromLast);
